var keyboardAccessibility = require("base/components/keyboardAccessibility");
var {
    setFocusOnFirstMenuItem,
    hideHeaderBanner,
    menuAccessibility,
    handleNavSubscribeClick,
    clearSelection,
    clearAllSelectionOnClose
} = require("coremh/components/menuHelpers");

module.exports = function () {
    var isDesktop = function (element) {
        return $(element).parents(".menu-toggleable-left").css("position") !== "fixed";
    };

    hideHeaderBanner();
    menuAccessibility();

    $(".dropdown:not(.disabled) [data-toggle=\"dropdown\"]")
        .on("click", function (e) {
            if (!isDesktop(this)) {
                e.preventDefault();
                var li = $("<li class=\"dropdown-item top-category\" role=\"button\"></li>");
                var link = $(this).clone().removeClass("dropdown-toggle")
                    .removeAttr("data-toggle")
                    .removeAttr("aria-expanded")
                    .attr("aria-haspopup", "false");
                li.append($(".back").first().clone());
                li.append(link);
                $(this).parent().children(".dropdown-menu").prepend(li);
                $(".modal-background").modal("show");
                $(this).parent().addClass("show");
                $(this).attr("aria-expanded", "true");
                $("div.menu-group > ul.nav.navbar-nav > li.nav-item > a").attr("aria-hidden", "true");
            }
        })
        .on("mouseenter", function () {
            if (isDesktop(this)) {
                var eventElement = this;
                $(".navbar-nav > li").each(function () {
                    if (!$.contains(this, eventElement)) {
                        $(this).find(".show").each(function () {
                            clearSelection(this, true);
                        });
                        if ($(this).hasClass("show")) {
                            $(this).removeClass("show");
                            $(this).children("ul.dropdown-menu").removeClass("show");
                            $(this).children(".nav-link").attr("aria-expanded", "false");
                        }
                    }
                });
                // need to close all the dropdowns that are not direct parent of current dropdown
                $(this).parent().addClass("show");
                $(this).siblings(".dropdown-menu:not(.dropdown-submenu)").addClass("show");
                $(this).attr("aria-expanded", "true");
            }
        })
        .parent()
        .on("mouseleave", function () {
            if (isDesktop(this)) {
                $(this).removeClass("show");
                $(this).children(".dropdown-menu").removeClass("show");
                $(this).children(".nav-link").attr("aria-expanded", "false");
            }
        });

    $(".navbar>.close-menu>.close-button").on("click", function (e) {
        e.preventDefault();
        clearAllSelectionOnClose();
        $(".navbar-nav").find(".show").removeClass("show");
        $("body").removeClass("menu-active");
        $(".navbar-nav").find(".dropdown-menu").hide();
        $(".menu-toggleable-left").removeClass("in");
        $(".modal-background").modal("hide");
        $(".navbar-toggler").focus();
        $(".main-menu").attr("aria-hidden", "true");
        $(".main-menu").siblings().attr("aria-hidden", "false");
        $("header").siblings().attr("aria-hidden", "false");
    });

    $(".navbar-nav").on("click", ".back", function (e) {
        e.preventDefault();
        clearSelection(this, true);
    });

    $(".navbar-toggler").click(function (e) {
        e.preventDefault();
        $(".main-menu").toggleClass("in");
        $("body").toggleClass("menu-active");
        $(".modal-background").modal("toggle");
        $(".main-menu").removeClass("d-none");
        $(".main-menu").attr("aria-hidden", "false");
        $(".main-menu").siblings().attr("aria-hidden", "true");
        $("header").siblings().attr("aria-hidden", "true");

        $(".main-menu .nav.navbar-nav .nav-link").first().focus();
    });

    keyboardAccessibility(".navbar-header .user",
        {
            40: function ($popover) { // down
                if ($popover.children("a").first().is(":focus")) {
                    setFocusOnFirstMenuItem($popover);
                } else {
                    $popover.children("a").first().focus();
                }
            },
            38: function ($popover) { // up
                if ($popover.children("a").first().is(":focus")) {
                    $(this).focus();
                    $popover.removeClass("show");
                } else {
                    $popover.children("a").first().focus();
                }
            },
            27: function () { // escape
                $(".navbar-header .user .popover").removeClass("show");
                $(".user [role='button']").attr("aria-expanded", "false");
            }
        },
        function () {
            return $(".user .popover li.nav-item");
        }
    );
    keyboardAccessibility(".account-submit-btn",
        {
            9: function () { // tab
                $(this).next().focus();
                $(".user [role='button']").attr("aria-expanded", "false");
            }
        },
        function () {
            return $(".minicart-total .popover li.nav-item");
        }
    );

    if ($(window).width() > 768) {
        $(".navbar-header .user").on("mouseenter", function () {
            if ($(".navbar-header .user .popover").length > 0) {
                $(".navbar-header .user .popover").addClass("show");
                $(".user [role='button']").attr("aria-expanded", "true");
            }
        });

        $(".navbar-header .user").on("mouseleave", function () {
            if (!$(".login-form-popin-email").is(":focus") && !$(".login-form-popin-password").is(":focus")) {
                $(".navbar-header .user .popover").removeClass("show");
                $(".user [role='button']").attr("aria-expanded", "false");
            }
        });
    }

    handleNavSubscribeClick(true);
};
